import { InjectionToken, Type } from '@angular/core';

export interface ViewComponentProviderConfig<T = unknown> {
  id: string;
  type: string;
  componentType: Type<T>;
}
export interface ViewComponentProvider<T = unknown> {
  id: string;
  type: string;
  componentType: Type<T>;
}

export const VIEW_COMPONENT = new InjectionToken<Type<unknown>[]>('VIEW_COMPONENT', {
  providedIn: 'root',
  factory: () => [],
});

export function provideViewComponentToken<T>(provide: InjectionToken<ViewComponentProvider<T>[]>, provider: ViewComponentProviderConfig) {
  return {
    provide,
    useValue: {} as ViewComponentProvider<T>,
    multi: true,
  };
}
